import { module } from 'modujs';

export default class extends module {
    init() {
        this.anim = gsap.fromTo(this.el,
            {
                rotate: 15
            },
            {
                rotate: -15,
                duration: 1

            }
        );
        this.anim.pause();
    }

    progress(value) {
        this.anim.progress(value);
    }
}
